import {
  AIRecommendation,
  Escalation,
  Location,
  UnifiedMonitoringProduct,
} from '@hakimo-ui/hakimo/types';
import { Button } from '@hakimo-ui/shared/ui-base';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { EscalationState } from '../types';
import { escalationFromState } from '../utils';
import ResolveEscalationModal from './ResolveEscalationModal';
import { useSavedDescription } from './useSavedDescription';

interface Props {
  escalationState: EscalationState;
  onResolveEscalation: (
    comment?: string,
    reason?: string,
    category?: string
  ) => void;
  alarmId: string;
  cameraNames?: string[];
  aiOperatorRep?: AIRecommendation;
  location: Location;
}

export function ScanEscalationBanner(props: Props) {
  const {
    escalationState,
    onResolveEscalation,
    alarmId,
    cameraNames = [],
    aiOperatorRep,
    location,
  } = props;

  const [showResolveModal, setShowResolveModal] = useState(false);

  const [description, onDescriptionSaved] = useSavedDescription(
    escalationState.comment
  );
  const escalation: Escalation = {
    ...escalationFromState(escalationState),
    description,
  };

  const formattedLocalTime = escalationState.escalationOpenTimestamp
    ? new Date(escalationState.escalationOpenTimestamp).toLocaleString(
        'en-US',
        {
          dateStyle: 'medium',
          timeStyle: 'medium',
        }
      )
    : '';

  return (
    <div className="w-full">
      <div className="grid grid-cols-12 rounded-md border border-red-200 bg-red-50 px-4 py-2 text-sm dark:border-red-500/50 dark:bg-red-700/50">
        <div className="col-span-1 flex items-center justify-center">
          <ExclamationTriangleIcon className="h-5 w-5" />
        </div>
        <div className="col-span-7 text-red-800 dark:text-red-200">
          <div className="flex gap-4">
            <span className="font-bold">Active Escalation: </span>
            <span>{description}</span>
          </div>
          <div className="text-xs">Reported at: {formattedLocalTime}</div>
        </div>
        <div className="col-span-4 text-end">
          <Button onClick={() => setShowResolveModal(true)} variant="success">
            Resolve
          </Button>
        </div>
      </div>
      {showResolveModal && (
        <ResolveEscalationModal
          alarmId={alarmId}
          escalation={escalation}
          location={location}
          onDescriptionSaved={onDescriptionSaved}
          onClose={() => setShowResolveModal(false)}
          product={UnifiedMonitoringProduct.SCAN}
          cameraNames={cameraNames}
          onResolveEscalation={onResolveEscalation}
          aiOperatorRep={aiOperatorRep}
        />
      )}
    </div>
  );
}

export default ScanEscalationBanner;
